import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { BrochureTemplate } from "#/components/templates/brochure-template";
import type { Dict, Locale } from "#/lib/i18n";
import { useI18n } from "#/lib/i18n";
import { getTrainingBySlug } from "#/lib/training";

export const Route = createFileRoute("/brochure/$slug")({
	loader: ({ params }) => getTrainingBySlug({ data: params.slug }),
	head: ({ loaderData }) => {
		if (!loaderData) return {};
		const content = loaderData.content as Record<Locale, Dict>;
		const { metaTitle, metaDescription } = content.ar.brochure;

		return {
			meta: [
				{ title: metaTitle },
				{ name: "description", content: metaDescription },
				{ name: "robots", content: "noindex, nofollow" },
			],
		};
	},
	component: BrochurePage,
});

function BrochurePage() {
	const training = Route.useLoaderData();
	const { locale } = useI18n();
	const content = (training.content as Record<Locale, Dict>)[locale];

	// Keep the tab title in sync on client-side navigations between trainings
	// or locale switches — head() only covers the initial SSR render.
	useEffect(() => {
		document.title = content.brochure.metaTitle;
	}, [content]);

	return (
		<BrochureTemplate
			content={content}
			trainingSlug={training.slug}
			trainerAvatarPath={
				training.trainerAvatarPath ?? "/team/ayoub-avatar.webp"
			}
			brochurePdfAr={
				training.brochurePdfAr ?? "/downloads/fiche-technique-ar.pdf"
			}
			brochurePdfFr={
				training.brochurePdfFr ?? "/downloads/fiche-technique-fr.pdf"
			}
		/>
	);
}
